var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 145v-34c0-16.262-14.196-30-31-30h-114c-16.542 0-30 13.458-30 30v34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337 175v226c0 16.542 13.458 30 30 30h114c16.804 0 31-13.738 31-30v-226zm91.36 191.35c-7.436 2.216-15.909-1.397-18.71-9.99-2.249-7.541 1.534-16.011 10-18.71 8.201-2.494 17.18 2.403 19.06 11.42 1.357 7.25-2.368 14.679-10.35 17.28zm0-64c-7.43 2.214-15.909-1.396-18.71-9.99-2.249-7.541 1.534-16.011 10-18.71 8.201-2.494 17.18 2.403 19.06 11.42 1.357 7.25-2.368 14.679-10.35 17.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m273 81h-243c-16.54 0-30 13.46-30 30v203c0 16.54 13.46 30 30 30h243c16.54 0 30-13.46 30-30v-203c0-16.54-13.46-30-30-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 401h-33v-27h-94v27h-33c-8.28 0-15 6.72-15 15s6.72 15 15 15h160c8.28 0 15-6.72 15-15s-6.72-15-15-15z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/Computer.faabd725.svg";
export { ForwardRef as ReactComponent };